import _ from "lodash";
/** external */
import React from "react";
import classNames from "classnames";
import { IconButton } from "@toddle-edu/ds-web";
import { CollapseArrowsTwoOutlined } from "@toddle-edu/ds-icons";
import PropTypes from "prop-types";
/** internal */
import { useI18n } from "Hooks";
/** relative */
import classes from "./WorksheetToolsHeader.scss";

const WorksheetToolsHeader = props => {
  const {
    questionIndex,
    label,
    toggleFullScreenEvaluation,
    showCollapseIcon,
    headerStyle,
  } = props;

  const { t } = useI18n(["common", "worksheet"]);

  const indexClasses = classNames("heading-5", classes.index);
  const headerLabelClasses = classNames(classes.label, "text-label-1");

  return (
    <div className={classes.headerContainer} style={headerStyle}>
      <div className={classes.leftHeader}>
        <div className={indexClasses}>
          {t("worksheet:question_abbreviation_with_number", {
            number: questionIndex,
          })}
        </div>
        <div className={classes.titleContainer} dir="auto">
          {_.isNil(label) ? null : (
            <div className={headerLabelClasses}>{label}</div>
          )}
        </div>
      </div>
      {showCollapseIcon ? (
        <IconButton
          dsVersion="2.0"
          type="plain"
          variant="neutral"
          size="medium"
          _legacy_size={"small"}
          icon={<CollapseArrowsTwoOutlined />}
          _legacy_variant={"plain"}
          onClick={toggleFullScreenEvaluation}
          testId="worksheet-worksheetToolsHeader-fullScreenToggle"
        />
      ) : null}
    </div>
  );
};

WorksheetToolsHeader.prototype = {
  questionIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  toggleFullScreenEvaluation: PropTypes.func,
  showCollapseIcon: PropTypes.bool,
  headerStyle: PropTypes.object,
};

WorksheetToolsHeader.defaultProps = {
  showCollapseIcon: false,
  headerStyle: {},
};

export default WorksheetToolsHeader;
